<template>
    <VJoyButton
        v-if="hasLocale"
        variant="ghost"
        size="small"
        data-testid="locale-selection-button"
        class="unlogged-navbar__locale-selection-button"
        :aria-label="$t('navbar.feat.locale-selection.dialog.language.select.label')"
        :disabled="loading"
    >
        <VJoyWrapper align="center" justify="center" column-gap="2" wrap="nowrap" no-margin>
            <VJoyIcon size="xsmall" :name="iconName" />
            {{ locale }}
        </VJoyWrapper>
    </VJoyButton>
    <VJoyIconButton
        v-else
        variant="ghost"
        size="xsmall"
        data-testid="locale-selection-button"
        class="unlogged-navbar__locale-selection-button"
        :label="$t('navbar.feat.locale-selection.dialog.cta.open')"
        :disabled="loading"
        :icon="iconName"
    />
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {useMouseHover} from '@malt/utils';
    import {VJoyButton, VJoyIcon, VJoyIconButton, VJoyWrapper} from '@maltjoy/core-vue';

    interface Props {
        loading?: boolean;
        locale?: string;
    }

    const {loading = false, locale} = defineProps<Props>();

    const {isHovering} = useMouseHover();
    const hasLocale = computed(() => !!locale);
    const iconName = computed(() => (isHovering.value ? 'globe-hover' : 'globe'));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/text' as text;

    .unlogged-navbar__locale-selection-button {
        &,
        * {
            @include text.getFontBySize(primary-250);

            color: var(--navbar-text-color, var(--joy-color-neutral-60));
            transition: color var(--navbar-scroll-transition-duration) var(--navbar-transition-easing);
        }

        &.joy-button {
            --button-font-size: var(--joy-font-size-primary-200);
            --button-padding: 6px var(--joy-core-spacing-5);

            &.joy-button_small {
                min-height: 0;
                border-radius: var(--joy-core-spacing-6);
                padding: var(--button-padding);
            }

            &:focus {
                outline: var(--joy-core-spacing-0) solid var(--joy-color-neutral-40);
                outline-offset: -1px;
                border-color: transparent;
            }
        }
    }
</style>
